<template>
  <v-dialog v-model="isOpened" max-width="400px" persistent @click:outside="handleCancel">
    <v-card>
      <v-card-title class="pb-2">
        <span class="text-h6">{{ title || '비밀번호 변경' }}</span>
      </v-card-title>
      
      <!-- 메시지 -->
      <v-card-text v-if="message" class="pb-2">
        <p class="text-body-1">{{ message }}</p>
      </v-card-text>
      
      <v-card-text class="pb-2">
        <v-form @submit.prevent="handleSubmit">
          <v-text-field
            v-model="password"
            label="현재 비밀번호"
            placeholder="현재 비밀번호를 입력하세요"
            variant="outlined"
            density="compact"
            type="password"
            required
            ref="passwordInput"
            class="mb-2"
            v-if="!forced"
          ></v-text-field>
          
          <v-text-field
            v-model="newPassword"
            label="새 비밀번호"
            placeholder="새 비밀번호를 입력하세요"
            variant="outlined"
            density="compact"
            type="password"
            required
            class="mb-2"
          ></v-text-field>
          
          <v-text-field
            v-model="confirmPassword"
            label="새 비밀번호 확인"
            placeholder="새 비밀번호를 다시 입력하세요"
            variant="outlined"
            density="compact"
            type="password"
            required
            class="mb-2"
            @keyup.enter="handleSubmit"
            :error-messages="passwordMismatchError"
          ></v-text-field>
        </v-form>
      </v-card-text>
      
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="handleCancel"
          :disabled="isLoading"
          size="small"
        >
          {{ cancelText || '취소' }}
        </v-btn>
        <v-btn
          color="primary"
          variant="text"
          @click="handleSubmit"
          :loading="isLoading"
          :disabled="!isFormValid"
          size="small"
        >
          {{ okText || '변경' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, nextTick, computed } from 'vue';
import { usePasswordChangeStore } from "@/stores/passwordChange";
import { storeToRefs } from "pinia";

const store = usePasswordChangeStore();
const {
  isOpened, title, message, cancelText, okText, password, newPassword, confirmPassword, forced, isLoading
} = storeToRefs(store);
const { close } = store;

const passwordInput = ref(null);

// 비밀번호 확인 에러 메시지
const passwordMismatchError = computed(() => {
  if (!confirmPassword.value) return '';
  if (newPassword.value !== confirmPassword.value) {
    return '새 비밀번호가 일치하지 않습니다.';
  }
  return '';
});

// 폼 유효성 검사
const isFormValid = computed(() => {
  return (forced.value || password.value.trim()) &&
         newPassword.value.trim() &&
         confirmPassword.value.trim() &&
         newPassword.value === confirmPassword.value &&
         newPassword.value.length >= 4; // 최소 4자리
});

// 취소 처리
const handleCancel = () => {
  close(null);
};

// 제출 처리
const handleSubmit = () => {
  if (!isFormValid.value) {
    return;
  }
  
  // 비밀번호 변경 데이터를 반환
  close({
    forced: forced.value,
    password: password.value,
    newPassword: newPassword.value
  });
};

// 다이얼로그 열림/닫힘 감지
watch(isOpened, async (newValue) => {
  if (newValue) {
    // 다이얼로그가 열리면 첫 번째 입력필드에 포커스
    await nextTick();
    passwordInput.value?.focus();
  }
});
</script>

<style scoped>
</style>
